function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,52.000000) scale(0.100000,-0.100000)",
  fill: "#707070",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 260 l0 -260 260 0 260 0 0 260 0 260 -260 0 -260 0 0 -260z m500 0 l0 -240 -240 0 -240 0 0 240 0 240 240 0 240 0 0 -240z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 260 l0 -220 220 0 220 0 0 220 0 220 -220 0 -220 0 0 -220z m80 100 l0 -100 -30 0 -30 0 0 100 0 100 30 0 30 0 0 -100z m260 -100 l0 -200 -120 0 -120 0 0 200 0 200 120 0 120 0 0 -200z m80 100 l0 -100 -30 0 -30 0 0 100 0 100 30 0 30 0 0 -100z m-340 -210 l0 -90 -30 0 -30 0 0 90 0 90 30 0 30 0 0 -90z m340 0 l0 -90 -30 0 -30 0 0 90 0 90 30 0 30 0 0 -90z"
}));

function SvgF50(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "52.000000pt",
    height: "52.000000pt",
    viewBox: "0 0 52.000000 52.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF50);
export default __webpack_public_path__ + "static/media/F50.408e40773fdec35770dce14f68ab426b.svg";
export { ForwardRef as ReactComponent };